module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/background_vehicle_enhancements.6d486602.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/background_vehicle_enhancements.png
// module id = 1049
// module chunks = 16